import { ToWords } from "to-words/en-IN";
import type { ReceiptLineItem } from "@/components/common-receipt/CommonReceiptA5";
import {
  defaultA5ChromeProps,
  onlineOrPlainPaymentText,
} from "@/components/common-receipt/a5-print-defaults";

const toWords = new ToWords();

export type RentReceiptPrintRecord = {
  id?: string | number;
  receiptNo?: string;
  date?: string;
  organiser?: string;
  organiserIts?: string;
  amount?: number;
  mode?: string;
  ref?: string;
  createdBy?: string;
};

export function rentReceiptPaymentText(data: RentReceiptPrintRecord): string {
  return onlineOrPlainPaymentText(data.mode, data.ref);
}

export function rentReceiptLines(data: RentReceiptPrintRecord): ReceiptLineItem[] {
  const paymentText = rentReceiptPaymentText(data);
  return [
    {
      left: "Received from",
      right: `${data.organiser || ""} ${data.organiserIts ? `(ITS - ${data.organiserIts})` : ""}`,
      bold: true,
    },
    {
      left: "The sum of Rupees",
      right: `${toWords.convert(Number(data.amount) || 0)} Only`,
      bold: true,
    },
    {
      left: "Received by / Towards",
      right: `${paymentText} towards Voluntary Contribution`,
    },
  ];
}

export function rentReceiptA5Props(data: RentReceiptPrintRecord) {
  return {
    ...defaultA5ChromeProps(),
    receiptNo: data.receiptNo,
    date: data.date,
    receiptLines: rentReceiptLines(data),
    amount: Number(data.amount),
    digitalSignatureValue: `${data.id}|${data.createdBy}`,
  };
}
